import React from 'react'
import { Link } from 'react-router-dom'

const SearchFilter = ({ searchValue, setSearchValue }) => {
    return (
        <>
            <div>
                <div className="input-group search-area">
                    <input
                        type="text"
                        className="form-control"
                        placeholder="Search here..."
                         value={searchValue}
                        onChange={(e) => setSearchValue(e.target.value)}
                    />
                    <span className="input-group-text">
                        <Link to={"#"}><i className="flaticon-381-search-2"></i></Link>
                    </span>
                </div>
            </div>
        </>
    )
}

export default SearchFilter